const POSTHOG_CONFIG = {
  API_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY || "<YOUR-PROJECT-API-KEY>",
  HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://app.posthog.com",
};

export default POSTHOG_CONFIG;
